import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlBoolean } from '../ControlBoolean'

import { control } from './control'

/**
 * @param {string} name
 * @param {boolean} value
 * @param {Object} defaultProps
 */
export function boolean(name, value = false, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlBoolean, defaultProps)
}
